import { render } from "./GroupsAddInfo.vue?vue&type=template&id=0ee7d482&scoped=true&ts=true"
import script from "./GroupsAddInfo.vue?vue&type=script&lang=ts"
export * from "./GroupsAddInfo.vue?vue&type=script&lang=ts"

import "./GroupsAddInfo.vue?vue&type=style&index=0&id=0ee7d482&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ee7d482"]])

export default __exports__